import { SESSION_KEYS, OAUTH_CONFIG } from '../constants/auth.constants';

/**
 * OAuth session management utilities
 */
export class SessionUtils {
    /**
     * Stores PKCE data in session storage
     */
    static storePKCEData(verifier: string, stateToken: string): void {
        sessionStorage.setItem(SESSION_KEYS.PKCE_VERIFIER, verifier);
        sessionStorage.setItem(SESSION_KEYS.PKCE_STATE, stateToken);
        sessionStorage.setItem(SESSION_KEYS.OAUTH_FLOW_STARTED, Date.now().toString());
    }

    /**
     * Retrieves PKCE verifier from session
     */
    static getPKCEVerifier(): string | null {
        return sessionStorage.getItem(SESSION_KEYS.PKCE_VERIFIER);
    }

    /**
     * Retrieves state token from session
     */
    static getStateToken(): string | null {
        return sessionStorage.getItem(SESSION_KEYS.PKCE_STATE);
    }

    /**
     * Clears OAuth session data
     */
    static clearOAuthSession(): void {
        sessionStorage.removeItem(SESSION_KEYS.PKCE_VERIFIER);
        sessionStorage.removeItem(SESSION_KEYS.PKCE_STATE);
        sessionStorage.removeItem(SESSION_KEYS.OAUTH_FLOW_STARTED);
    }

    /**
     * Checks if OAuth flow exists
     */
    static hasOAuthFlow(): boolean {
        return !!(this.getPKCEVerifier() || this.getStateToken());
    }

    /**
     * Checks if OAuth session has expired
     */
    static hasOAuthSessionExpired(): boolean {
        const flowStarted = sessionStorage.getItem(SESSION_KEYS.OAUTH_FLOW_STARTED);
        if (!flowStarted) return false;

        const startTime = parseInt(flowStarted, 10);
        return Date.now() - startTime > OAUTH_CONFIG.OAUTH_FLOW_MAX_AGE_MS;
    }

    /**
     * Sets flag to use legacy login
     */
    static setUseLegacyLogin(): void {
        sessionStorage.setItem(SESSION_KEYS.USE_LEGACY_LOGIN, 'true');
    }

    /**
     * Checks and clears legacy login flag
     */
    static checkAndClearLegacyFlag(): boolean {
        const useLegacy = sessionStorage.getItem(SESSION_KEYS.USE_LEGACY_LOGIN) === 'true';
        if (useLegacy) {
            sessionStorage.removeItem(SESSION_KEYS.USE_LEGACY_LOGIN);
        }
        return useLegacy;
    }

    /**
     * Clears all session flags
     */
    static clearAllFlags(): void {
        Object.values(SESSION_KEYS).forEach(key => {
            if (typeof key === 'string') {
                sessionStorage.removeItem(key);
            }
        });
    }
}